import LawyerList from './lawyer-list.vue'
export default LawyerList



// WEBPACK FOOTER //
// ./src/common-components/lawyer-list/index.js